import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { CompetenceGroupsService } from "../../core/competencegroups.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "crew-edit-competencegroup",
    template: require('../shared/edit-view.html')
})
export class EditCompetenceGroup extends EditBase<Nema.Crew.Model.CompetenceGroup> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('competencegroup') entity: Nema.Crew.Model.CompetenceGroup,
        @Inject('competenceGroupsService') competenceGroupsService: CompetenceGroupsService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, entity, competenceGroupsService, $log, isNew);
    }

    public entityDisplayName = "Competence Group";

    public listStateName = "app.settings.competencegroups";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/competencegroups/competencegroup.edit.component.ts